import { render, staticRenderFns } from "./SelectorEmpresaPropia.vue?vue&type=template&id=185fe6f2"
import script from "./SelectorEmpresaPropia.vue?vue&type=script&lang=js"
export * from "./SelectorEmpresaPropia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports